// Порядок окон обучения: НАГРАДА ВПЕРЁД, следующий шаг — потом (фидбек оунера 2026-07-29).
//
// Каждый шаг-действие заканчивается роллом награды. Раньше экран уводил игрока на следующий раздел
// сразу после ответа сервера, и окно награды всплывало уже поверх нового экрана — вместе с его
// подсказкой. Теперь любой АВТОПЕРЕХОД ждёт, пока игрок закроет награду.

/**
 * Дождаться закрытия окна награды за шаг обучения.
 * Награды нет — резолвится сразу. Таймаут-страховка: интерфейс не должен зависнуть, если окно
 * почему-то не закрылось (ошибка рендера, ручная навигация).
 */
export function waitReward(store, timeout = 20000) {
  return new Promise((resolve) => {
    // ждём ИМЕННО `tutorialBusy`: между отправкой шага и приходом награды окна ещё нет, но
    // уводить игрока уже нельзя — иначе награда всплывёт поверх следующего экрана
    if (!store.getters.tutorialBusy) { resolve(); return; }
    let timer = null;
    const stop = store.watch(
      (state, getters) => getters.tutorialBusy,
      (value) => {
        if (value) return;
        if (timer) clearTimeout(timer);
        stop();
        resolve();
      },
    );
    timer = setTimeout(() => { stop(); resolve(); }, timeout);
  });
}

export default { waitReward };
